import { render } from "./LoadBalancerSelection.vue?vue&type=template&id=10d65536&scoped=true"
import script from "./LoadBalancerSelection.vue?vue&type=script&lang=js"
export * from "./LoadBalancerSelection.vue?vue&type=script&lang=js"

import "./LoadBalancerSelection.vue?vue&type=style&index=0&id=10d65536&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d65536"]])

export default __exports__